import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import digital from '../../../assets/img/digital.svg';
import tax from '../../../assets/img/tax.svg';
import astro from '../../../assets/img/astro.svg';
import heal from '../../../assets/img/heal.svg';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useRef } from 'react';
import { IMAGE_URL } from '../../../api';

const PostTask = (props) => {

    const [isOpen, setOpen] = useState(false);
    const { state, categories } = props;



    return (
        <React.Fragment>

            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="LXb3EKWsInQ" onClose={() => setOpen(false)} />
            <section className="post-task" data-aos="fade-up" data-aos-duration="2000">
                <header className="section-header" >
                    <p className="two">Post your task in easy steps</p>
                </header>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <form id="msform">
                                <ul id="progressbar">
                                    <li className="active">Describe what you need done</li>
                                    <li>Set your budget</li>
                                    <li>Receive quotes & pick the best person</li>
                                </ul>
                            </form>
                        </div>
                    </div>
                    <div className="row p-4 justify-content-center"   >
                        {categories?.map((category, index) =>
                            <div className="col-lg-3 col-md-4" key={index}>
                                <Link className="icon-box" to="/signin">
                                    {/* <i className="ri-store-line" style={{ color: "#ffbb2c" }}></i> */}
                                    <img src={IMAGE_URL + category?.logo} alt='Tax' className='img-fluid' />
                                    <h3>{category?.name}</h3>
                                </Link>
                            </div>
                        )}

                        {/* <div className="col-lg-2 col-md-4 mt-4 mt-lg-0">
                <a className="icon-box" href="/">
                  <i className="ri-database-2-line" style={{color: "#47aeff"}}></i>
                  <h3>Learn</h3>
                </a>
              </div> */}
                    </div>
                    {/* <div className="row">
                        <div className="col-lg-12">
                            <div className="text-center">
                                <button aria-current="page" className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center active" onClick={() => setOpen(true)} href="/">
                                    <i className="bi bi-play"></i> <span>See how it works </span>
                                </button>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>
        </React.Fragment>
    )
}

export default PostTask;